import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { EventType, type AuthenticationResult } from "@azure/msal-browser";

import { App } from "./App";
import { msalInstance } from "./auth/msalConfig";
import "./styles.css";

/**
 * MSAL has to finish initialising and process any pending redirect before React renders,
 * otherwise the first paint happens while the account is still unknown and the app flashes
 * the sign-in screen at someone who is already signed in.
 */
async function bootstrap(): Promise<void> {
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  const existing = msalInstance.getAllAccounts();
  if (existing.length > 0) {
    msalInstance.setActiveAccount(existing[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      msalInstance.setActiveAccount((event.payload as AuthenticationResult).account);
    }
  });

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>,
  );
}

void bootstrap();
